import React from 'react';
import "./packageCard.scss";

export default function PackageCard(props) {
  return (
    <div className='packageCard'>
        <div className='image-section'>
            <img src={props.imagesrc} alt=""></img>
            <button className='know-more-btn custom-button primary-btn' onClick={props.onKnowMoreClick}>
                Know More
            </button>
        </div>
        <div className='content' dangerouslySetInnerHTML={{ __html: props.cardContent }}>
 
        </div>
    </div>
  )
}
